// extracted by mini-css-extract-plugin
export default {"enquiry":"Enquiry_enquiry__hMi+-","letsChat":"Enquiry_letsChat__t8pUs","content":"Enquiry_content__DdE87"};